import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';
import './TAC.css';

const TAC = () => {
    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">Terms &amp; Conditions</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Terms &amp; Conditions</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* T&C Content Start */}
            <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container">

                    {/* Intro */}
                    <div className="tc-intro">
                        <h2>Agreement Overview</h2>
                        <p>This agreement governs <span className="hl">all services</span> provided by WebBears — including digital services, technology services, creative services, marketing, design, development, consulting, maintenance, and any other professional services. By accepting a quotation, making payment, or proceeding with work, the <span className="hl">Client agrees to all terms and conditions stated below.</span></p>
                    </div>

                    {/* 2. Payment Terms */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">02</span>
                            <h3>Payment Terms</h3>
                        </div>
                        <p>The total cost of the Project/Service will be as mentioned in the approved quotation or invoice. Unless stated otherwise, the following payment structure applies:</p>
                        <div className="pay-grid">
                            <div className="pay-box">
                                <div className="pct">50%</div>
                                <div className="pct-lbl">Advance to initiate the project</div>
                            </div>
                            <div className="pay-box">
                                <div className="pct">30%</div>
                                <div className="pct-lbl">Upon first agreed milestone completion</div>
                            </div>
                            <div className="pay-box">
                                <div className="pct">20%</div>
                                <div className="pct-lbl">Before final delivery / launch / handover</div>
                            </div>
                        </div>
                        <ul>
                            <li>Invoices will be issued as per milestones.</li>
                            <li>Payments must be made within <strong>30 days</strong> of the invoice date.</li>
                            <li>All payments are <strong>non-refundable</strong> once work has commenced.</li>
                            <li>WebBears reserves the right to pause or stop work in case of delayed or non-payment.</li>
                        </ul>
                    </div>

                    {/* 3. Scope of Work */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">03</span>
                            <h3>Scope of Work &amp; Limitation</h3>
                        </div>
                        <p>Only the services <strong>explicitly mentioned</strong> in the approved quotation are included in this agreement. The following shall be considered <strong>out of scope</strong> and charged separately:</p>
                        <ul>
                            <li>Additional deliverables not in the original quotation</li>
                            <li>Extra revisions beyond the agreed limit</li>
                            <li>New features, changes, or enhancements</li>
                            <li>Rework due to change in client requirements</li>
                            <li>Additional creative, design, marketing, or consulting tasks</li>
                        </ul>
                    </div>

                    {/* 4. Client Responsibilities */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">04</span>
                            <h3>Client Responsibilities</h3>
                        </div>
                        <p>The Client agrees to:</p>
                        <ul>
                            <li>Provide all required content, materials, inputs, approvals, and feedback on time.</li>
                            <li>Ensure all information provided is accurate and complete.</li>
                            <li>Respond promptly to communication from WebBears.</li>
                        </ul>
                        <div className="tc-warn">
                            <i className="fa fa-exclamation-triangle"></i>
                            <span>Any delay from the Client's side will result in delays in project timelines and may incur additional costs.</span>
                        </div>
                    </div>

                    {/* 5. Content & Media */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">05</span>
                            <h3>Content, Media &amp; Material Provision</h3>
                        </div>
                        <p>For services requiring content, media, or data:</p>
                        <ul>
                            <li>The Client is responsible for providing raw content such as text, images, videos, credentials, and other materials.</li>
                            <li>WebBears may guide the Client on content requirements, format, quality, or usage.</li>
                            <li>WebBears is <strong>not responsible</strong> for creating or sourcing content unless explicitly mentioned in the quotation.</li>
                            <li>Placeholder content may be used until the Client provides final materials.</li>
                        </ul>
                    </div>

                    {/* 6. Pricing */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">06</span>
                            <h3>Pricing Inclusions &amp; Exclusions</h3>
                        </div>
                        <p>Unless explicitly mentioned in the quotation, pricing includes <strong>execution of listed services only.</strong> The following third-party costs will be billed separately unless specified:</p>
                        <ul>
                            <li>Advertising spends</li>
                            <li>Software / tools / licenses</li>
                            <li>Hosting, domain, or platform fees</li>
                            <li>External services or integrations</li>
                        </ul>
                    </div>

                    {/* 7. Revisions */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">07</span>
                            <h3>Revisions Policy</h3>
                        </div>
                        <p>Revisions, if included, will be limited as specified in the quotation. Any revisions beyond the agreed limit will be <strong>chargeable</strong> at WebBears' standard pricing.</p>
                    </div>

                    {/* 8. Communication */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">08</span>
                            <h3>Communication &amp; Delay Clause</h3>
                        </div>
                        <ul>
                            <li><strong>7 consecutive days</strong> of no response will result in project delays.</li>
                            <li><strong>15 consecutive days</strong> of no communication will result in the project being marked as <em>Cancelled Due to No Communication.</em></li>
                        </ul>
                        <div className="tc-warn">
                            <i className="fa fa-exclamation-triangle"></i>
                            <span>In such cases: No refunds will be issued, all outstanding payments become immediately due, and re-initiation will require additional charges.</span>
                        </div>
                    </div>

                    {/* 9. Requirement Changes */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">09</span>
                            <h3>Requirement Changes &amp; Additional Costs</h3>
                        </div>
                        <p>Project pricing is based on the <strong>initial requirements.</strong> Any change in scope, features, deliverables, or timelines caused by:</p>
                        <ul>
                            <li>New requests or change in requirements</li>
                            <li>Delayed feedback or approvals</li>
                        </ul>
                        <p className="mt-2">…will result in <strong>revised costing and additional billing.</strong></p>
                    </div>

                    {/* 10. Project Validity */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">10</span>
                            <h3>Project Validity &amp; Timelines</h3>
                        </div>
                        <p>The quoted pricing assumes completion within the agreed timeline. If delays occur due to the Client's actions or inaction, WebBears reserves the right to revise pricing, including a monthly increase of up to <strong>20% of the project value</strong> for extended delays.</p>
                    </div>

                    {/* 11. Re-initiation */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">11</span>
                            <h3>Re-initiation of Services</h3>
                        </div>
                        <p>If services are paused or terminated due to non-payment or lack of communication, restarting the services will attract <strong>re-initiation charges.</strong></p>
                    </div>

                    {/* 12. Liability */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">12</span>
                            <h3>Limitation of Liability</h3>
                        </div>
                        <p>WebBears shall not be held liable for:</p>
                        <ul>
                            <li>Losses caused by incorrect or incomplete information provided by the Client.</li>
                            <li>Delays caused by third-party services or platforms.</li>
                            <li>Business losses, revenue loss, or indirect damages of any kind.</li>
                        </ul>
                    </div>

                    {/* 13. Confidentiality */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">13</span>
                            <h3>Confidentiality &amp; Non-Disclosure</h3>
                        </div>
                        <p>Both parties agree to keep all shared information <strong>strictly confidential</strong> during and after the engagement, unless required by law.</p>
                    </div>

                    {/* 14. Termination */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">14</span>
                            <h3>Termination Policy</h3>
                        </div>
                        <p>Either party may terminate this agreement with <strong>7 days' written notice.</strong> WebBears reserves the right to suspend or terminate services <strong>immediately</strong> in case of:</p>
                        <ul>
                            <li>Non-payment</li>
                            <li>Breach of agreement</li>
                            <li>Lack of communication</li>
                        </ul>
                    </div>

                    {/* 15. Dispute Resolution */}
                    <div className="tc-card">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <span className="tc-num">15</span>
                            <h3>Dispute Resolution &amp; Jurisdiction</h3>
                        </div>
                        <p>All disputes shall be resolved under the <strong>Arbitration &amp; Conciliation Act, 1996, India.</strong> Jurisdiction shall be governed by <strong>Indian law.</strong></p>
                        <div className="tc-info">
                            <i className="fa fa-balance-scale"></i>
                            <span>WebBears is headquartered in Thane, Maharashtra, India. All legal matters shall be subject to this jurisdiction.</span>
                        </div>
                    </div>

                    {/* 16. Acceptance */}
                    <div className="accept-card">
                        <h3>Agreement Acceptance</h3>
                        <p>Acceptance of any of the following shall be considered <strong>legally valid acceptance</strong> of this entire agreement:</p>
                        <div className="accept-methods">
                            <span className="accept-tag"><i className="fa fa-file-invoice me-2"></i>Quotation Approval</span>
                            <span className="accept-tag"><i className="fa fa-receipt me-2"></i>Invoice Acceptance</span>
                            <span className="accept-tag"><i className="fa fa-envelope me-2"></i>Email Confirmation</span>
                            <span className="accept-tag"><i className="fab fa-whatsapp me-2"></i>WhatsApp Approval</span>
                            <span className="accept-tag"><i className="fa fa-credit-card me-2"></i>Payment</span>
                        </div>
                    </div>

                </div>
            </div>
            {/* T&C Content End */}

            <Footer />
        </>
    );
};

export default TAC;
